var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"textinput",attrs:{"rows":_vm.rows,"placeholder":_vm.placeholder},domProps:{"value":(_vm.currentValue)},on:{"input":[function($event){if($event.target.composing)return;_vm.currentValue=$event.target.value},_vm.onInput]}})
}
var staticRenderFns = []

export { render, staticRenderFns }